var newsletterSub = document.querySelector('.form__sub'),
    newsletterButton = document.querySelector('.newsletter__button'),
    newsletterSubButton = document.querySelector('.newsletter__sub-button'),
    newsletterThanks = document.querySelector('.newsletter__thanks'),
    newsletterForm = document.querySelector('.newsletter__form');

if (newsletterButton) {
    newsletterButton.addEventListener('click', function(e) {
        e.preventDefault();
        this.classList.add('hidden');
        newsletterSub.classList.remove('hidden');
        newsletterSubButton.classList.remove('hidden');
    })
}

if (newsletterSubButton) {
    newsletterSubButton.addEventListener('click', function(e) {
        e.preventDefault();
        newsletterForm.classList.add('hidden');
        newsletterThanks.classList.remove('hidden');
    })
}
